import { Navigation } from '@src/routing/Navigation';
import { useSearchParams } from 'react-router-dom';

export const useCurrentOrderMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const mode =
    searchParams.get(Navigation.orderMode.searchParamKey) ?? 'summary';

  const setCurrentMode = (
    mode:
      | { mode: 'summary' }
      | { mode: 'permitNotes'; permitId: string }
      | { mode: 'review' }
      | { mode: 'reviewPermitNotes'; permitId: string }
      | { mode: 'viewInvoice' },
  ) => {
    if (mode.mode === 'summary') {
      searchParams.delete(Navigation.permit.searchParamKey);
    }

    if (mode.mode === 'permitNotes') {
      searchParams.set(Navigation.permit.searchParamKey, mode.permitId);
    }

    if (mode.mode === 'reviewPermitNotes') {
      searchParams.set(
        Navigation.reviewPermitNotes.searchParamKey,
        mode.permitId,
      );
    }

    searchParams.set(Navigation.orderMode.searchParamKey, mode.mode);
    setSearchParams(searchParams);
  };

  return {
    mode,
    setCurrentMode,
  };
};
